export const changeAmountEvt = new window.Event('amountChange')